/**
 * Translations for Olivio Configurator
 */

var TRANSLATIONS = TRANSLATIONS || {};

// actual information is split up to individual files

// add functions like this: TRANSLATIONS.foo = function() {};

